import React from 'react'
import './Button.css'
import { Button as BsButton } from 'reactstrap'

const Button = props => {
  return <BsButton {...props} />
}

export default Button
